import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-review-product',
  templateUrl: './review.component.html',
  styleUrls: ['./review.component.scss'],
})
export class ReviewComponentProduct implements OnInit {
  // @Input() set (value){
  //   if(value) console.log(value);
  // };
  @Input() reviews: any[] = [];
  @Input() productId = undefined;

  constructor() { }

  ngOnInit() {   
  }

}
